/**
 * Country code mappings for international phone numbers
 * Maps country names to their international dialing codes
 */

export const COUNTRY_CODES = {
  'United States': '+1',
  'Canada': '+1',
  'United Kingdom': '+44',
  'Australia': '+61',
  'New Zealand': '+64',
  'Germany': '+49',
  'France': '+33',
  'Italy': '+39',
  'Spain': '+34',
  'Portugal': '+351',
  'Netherlands': '+31',
  'Belgium': '+32',
  'Switzerland': '+41',
  'Austria': '+43',
  'Sweden': '+46',
  'Norway': '+47',
  'Denmark': '+45',
  'Finland': '+358',
  'Poland': '+48',
  'Czech Republic': '+420',
  'Czechia': '+420',
  'Hungary': '+36',
  'Romania': '+40',
  'Bulgaria': '+359',
  'Greece': '+30',
  'Turkey': '+90',
  'Russia': '+7',
  'Ukraine': '+380',
  'Ireland': '+353',
  'Iceland': '+354',
  'Luxembourg': '+352',
  'Malta': '+356',
  'Cyprus': '+357',
  'Estonia': '+372',
  'Latvia': '+371',
  'Lithuania': '+370',
  'Slovakia': '+421',
  'Slovenia': '+386',
  'Croatia': '+385',
  'Serbia': '+381',
  'Bosnia and Herzegovina': '+387',
  'Montenegro': '+382',
  'North Macedonia': '+389',
  'Albania': '+355',
  'Andorra': '+376',
  'Monaco': '+377',
  'Gibraltar': '+350',
  'Guernsey': '+44',
  'Jersey': '+44',
  'Isle of Man': '+44',
  'Japan': '+81',
  'South Korea': '+82',
  'China': '+86',
  'Hong Kong': '+852',
  'Hong Kong SAR China': '+852',
  'Taiwan': '+886',
  'Singapore': '+65',
  'Malaysia': '+60',
  'Thailand': '+66',
  'Indonesia': '+62',
  'Philippines': '+63',
  'Vietnam': '+84',
  'Brunei': '+673',
  'India': '+91',
  'Pakistan': '+92',
  'Bangladesh': '+880',
  'Sri Lanka': '+94',
  'Nepal': '+977',
  'United Arab Emirates': '+971',
  'Saudi Arabia': '+966',
  'Qatar': '+974',
  'Kuwait': '+965',
  'Bahrain': '+973',
  'Oman': '+968',
  'Israel': '+972',
  'Jordan': '+962',
  'Lebanon': '+961',
  'Syria': '+963',
  'Egypt': '+20',
  'South Africa': '+27',
  'Nigeria': '+234',
  'Kenya': '+254',
  'Morocco': '+212',
  'Algeria': '+213',
  'Tunisia': '+216',
  'Namibia': '+264',
  'Brazil': '+55',
  'Argentina': '+54',
  'Chile': '+56',
  'Colombia': '+57',
  'Peru': '+51',
  'Venezuela': '+58',
  'Mexico': '+52',
  'Uruguay': '+598',
};

/**
 * Get the country code for a given country name
 * @param {string} countryName - The name of the country
 * @returns {string|null} The country code (e.g., '+1', '+44') or null if not found
 */
export const getCountryCode = (countryName) => {
  if (!countryName) return null;

  // Try direct match first
  if (COUNTRY_CODES[countryName]) {
    return COUNTRY_CODES[countryName];
  }

  // Try with dashes replaced by spaces (e.g., "United-States" -> "United States")
  const normalizedName = countryName.replace(/-/g, ' ');
  if (COUNTRY_CODES[normalizedName]) {
    return COUNTRY_CODES[normalizedName];
  }

  return null;
};
